import { BTIconTrash } from "commonComponents/btWrappers/BTIcon";
import { BTMenu } from "commonComponents/btWrappers/BTMenu/BTMenu";

interface IMenuItemMoveToTrashProps {
    fileId: number;
    isTempFile: boolean;
    onClick: () => Promise<void>;
}

const MenuItemRemoveAttachment = ({
    fileId,
    isTempFile,
    onClick,
    ...antProps
}: IMenuItemMoveToTrashProps) => {
    return (
        <BTMenu.Item
            {...antProps}
            key={`removeAttachment-menuitem-${fileId}`}
            testid={`removeAttachment-menuitem-${fileId}`}
            onClick={onClick}
        >
            <BTIconTrash /> {isTempFile ? "Remove" : "Move to trash"}
        </BTMenu.Item>
    );
};

export default MenuItemRemoveAttachment;
